import { MutableRefObject, useContext } from 'react'
import { ILatLng } from '../../../../typings/IApiTrainingCommonBase'
import { GoogleTrainingMap } from './GoogleTrainingMap'
import UserContext from '../../../../contexts/UserContext'
import { MapTilerTrainingMap } from './MapTilerTrainingMap'


export interface ITrainingMap {
  isTracker: boolean
  selectStart: number
  selectEnd: number
  coords: ILatLng[] | undefined
  focusedTimeRef: MutableRefObject<number>
}

export function TrainingMap(props: ITrainingMap) {
  const { user } = useContext(UserContext)
  if (user && ['cn', 'hk'].includes(user.country)) {
    return <MapTilerTrainingMap {...props} />
  }
  return <GoogleTrainingMap {...props} />
}